export const AUTH = {
  LOGIN: '/auth/login',
  SIGNUP: '/auth/signup',
  ME: '/auth/me',
  ENGAGEMENT: '/auth/me/engagement',
  UPDATE_ME: '/auth/me',
  CHANGE_PASSWORD: '/auth/change-password',
};

export const PAGES = {
  FEED: ({ limit = 20, cursor } = {}) => {
    const params = new URLSearchParams();
    params.set('limit', String(limit));
    if (cursor) params.set('cursor', cursor);
    return `/pages/feed?${params.toString()}`;
  },
  ARTICLE: (id) => `/pages/article/${id}`,
  ALERTS: '/pages/alerts',
  PROFILE: '/pages/profile',
  ADMIN_DASHBOARD: '/pages/admin/dashboard',
  ADMIN_CONTENT: (status, q) => {
    const params = new URLSearchParams();
    if (status && status !== 'all') params.set('status', status);
    if (q) params.set('q', q);
    const qs = params.toString();
    return qs ? `/pages/admin/content?${qs}` : '/pages/admin/content';
  },
  ADMIN_SOURCES: '/pages/admin/sources',
  ADMIN_ALERTS: '/pages/admin/alerts',
  ADMIN_ANALYTICS: '/pages/admin/analytics',
};

export const FEED = {
  LIST: (limit = 20) => `/feed?limit=${limit}`,
};

export const ARTICLES = {
  BY_ID: (id) => `/articles/${id}`,
  VIEW: (id) => `/articles/${id}/views`,
  LIKE: (id) => `/articles/${id}/likes`,
  SHARE: (id) => `/articles/${id}/shares`,
  REACTIONS: (id) => `/articles/${id}/reactions`,
  COMMENTS: (id) => `/articles/${id}/comments`,
  ADMIN_LIST: (status) =>
    status && status !== 'all'
      ? `/admin/articles?status=${status}`
      : '/admin/articles',
  ADMIN_CREATE: '/admin/articles',
  SUBMIT: (id) => `/admin/articles/${id}/submit`,
  APPROVE: (id) => `/admin/articles/${id}/approve`,
  REJECT: (id) => `/admin/articles/${id}/reject`,
  PUBLISH: (id) => `/admin/articles/${id}/publish`,
  ADMIN_BY_ID: (id) => `/admin/articles/${id}`,
  UNPUBLISH: (id) => `/admin/articles/${id}/unpublish`,
  DELETE_COMMENT: (articleId, commentId) =>
    `/articles/${articleId}/comments/${commentId}`,
};

export const NOTIFICATIONS = {
  LIST: '/notifications',
  CREATE: '/notifications',
  EVENTS: (id) => `/notifications/${id}/events`,
  READ: (id) => `/notifications/${id}/read`,
  READ_ALL: '/notifications/read-all',
  ACTION: (id, actionId) => `/notifications/${id}/actions/${actionId}`,
  PEOPLE: (id) => `/notifications/${id}/people`,
};

export const SOURCES = {
  LIST: '/admin/sources',
  CREATE: '/admin/sources',
  BY_ID: (id) => `/admin/sources/${id}`,
  INGEST: (id) => `/admin/sources/${id}/ingest`,
  INGEST_ALL: '/admin/sources/ingest-all',
  SCHEDULER: '/admin/sources/scheduler',
};

export const NEWS_AGENT = {
  STATUS: '/admin/news-agent/status',
  SCRAPE: '/admin/news-agent/scrape',
  IMPORT: '/admin/news-agent/import',
};

export const ADMIN = {
  DASHBOARD: '/admin/dashboard',
  USER_ENGAGEMENT: (id) => `/admin/users/${id}/engagement`,
  ANALYTICS_OVERVIEW: '/admin/analytics/overview',
  ANALYTICS_ARTICLES: '/admin/analytics/articles',
  ANALYTICS_ARTICLE: (id) => `/admin/analytics/articles/${id}`,
  ANALYTICS_ARTICLE_PEOPLE: (id) => `/admin/analytics/articles/${id}/people`,
  ANALYTICS_ALERTS: '/admin/analytics/alerts',
  ANALYTICS_ALERT: (id) => `/admin/analytics/alerts/${id}`,
  ANALYTICS_AUDIENCE: '/admin/analytics/audience',
  ANALYTICS_OPS: '/admin/analytics/ops',
};

export const USERS = {
  LIST: '/admin/users',
  CREATE: '/admin/users',
  BY_ID: (id) => `/admin/users/${id}`,
  RESET_PASSWORD: (id) => `/admin/users/${id}/reset-password`,
};

export const PUSH = {
  VAPID_PUBLIC_KEY: '/push/vapid-public-key',
  DEVICES: '/devices',
  UNREGISTER: '/devices/unregister',
};
